import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'asv-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public year: number;
  constructor() {
    const date = new Date();
    this.year = date.getFullYear();
  }

  ngOnInit() {
  }

}
